import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';

var ModalHeader = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return React__default.createElement(Box, _extends({
    ref: ref,
    as: "header",
    padding: ['py-2', 'px-6'],
    position: "relative",
    display: "flex",
    height: "h-15",
    alignItems: "items-center",
    borderWidth: "border-b",
    borderColor: "border-gray-200"
  }, props));
});

if (__DEV__) {
  ModalHeader.displayName = 'ModalHeader';
}

export default ModalHeader;
//# sourceMappingURL=index.esm.js.map
